/**
 * OS からのファイルのドラッグ & ドロップ判定。
 *
 * プロジェクトの移動（@dnd-kit）はポインタイベントで動く別系統なので、ここでは扱わない。
 */

/**
 * サイドバーを示す属性。サイドバーでは、プロジェクト行以外に落としても
 * 開いているプロジェクトへは上げない（どこに入ったか利用者が分からなくなるため）。
 */
export const sidebarUploadScopeProps = { 'data-upload-scope': 'sidebar' } as const
const SIDEBAR_UPLOAD_SELECTOR = '[data-upload-scope="sidebar"]'

/** dragover の時点ではファイルの中身は読めないが、種類（types）は読める */
export function hasDraggedFiles(dataTransfer: Pick<DataTransfer, 'types'> | null): boolean {
  return Array.from(dataTransfer?.types ?? []).includes('Files')
}

export function isInsideSidebar(target: EventTarget | null): boolean {
  return target instanceof Element && target.closest(SIDEBAR_UPLOAD_SELECTOR) !== null
}
